import type { FontData } from '@jobilla/nexus-sdk'
import { atom } from 'jotai'

export const customFontsAtom = atom<FontData[]>([])
export const customFontsLoadingAtom = atom<boolean>(false)
